import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/contact/components/Contact.jsx");
